import { CSSObject } from '@emotion/react'

import { colors, screen } from '../../styles'

export const cssRecipeTile: CSSObject = {
  width: '100%',
  height: '100%',
  position: 'relative',
}

export const cssRecipeTileContainer: CSSObject = {
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: colors.white,
  color: colors.blackberry,
  position: 'relative',
  borderRadius: '4px',
  boxShadow: '0 1px 5px 0 rgba(51, 61, 71, 0.2)',

  '&:nth-of-type(2n)': {
    [`@media ${screen.screenSMMin} and ${screen.screenSMMax}`]: {
      marginRight: '0',
    },
  },

  '&:nth-of-type(3n)': {
    [`@media ${screen.screenMDMin} and ${screen.screenMDMax}`]: {
      marginRight: '0',
    },
  },

  '&:nth-of-type(4n)': {
    [`@media ${screen.screenLGMin}`]: {
      marginRight: '0',
    },
  },

  '&:hover': {
    boxShadow: '0 4px 14px 0 rgba(51, 61, 71, 0.2)',
    cursor: 'pointer',
  },
}

export const cssRecipeTagHolder: CSSObject = {
  position: 'absolute',
  top: '1rem',
  left: '1rem',
  display: 'flex',
}

export const cssAddRecipeButtonContainer: CSSObject = {
  position: 'absolute',
  // we need extra 1 rem because container element has 1 rem margin
  transform: 'translateY(calc(-50% - 1rem))',
  top: 0,
  right: 0,
  width: '48px',
  height: '48px',
  borderRadius: '6px',
  backgroundColor: '#FFFFFF',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 12,
}
